module.exports = "/_next/static/images/mp-3680ccd9f4fdfceb4617b181855a50a6.svg";